// SemanticUI-free pre-@plone/components
import React from 'react';

import { defineMessages, injectIntl } from 'react-intl';
import { useSelector, shallowEqual } from 'react-redux';
import { Logo } from '@plone/volto/components';
import { NarrowContainer, Container } from '../Container/Container';
import config from '@plone/volto/registry';
import './style.scss';

import { UniversalLink } from '@plone/volto/components';

const messages = defineMessages({
  copyright: {
    id: 'Copyright',
    defaultMessage: 'Copyright',
  },
});

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  const { settings } = config;
  const { lang, siteActions = [] } = useSelector(
    (state) => ({
      lang: state.intl.locale,
      siteActions: state.actions?.actions?.site_actions,
    }),
    shallowEqual,
  );




  return (
    <>
      <footer id="footer">
      <div className="footer-background" />

        <Container layout className="footer">
          <div className='ui twelve column grid column-grid icons'>
            <div className={`two wide computer twelve wide mobile six wide tablet column`}>
              <div className="logo">
                <Logo />
              </div>
            </div>

            <div className={`seven wide computer twelve wide mobile six wide tablet column `}>
            </div>
            <div className={`three wide computer twelve wide mobile six wide tablet column `}>
              <div className='footer-nav'>
                <UniversalLink href="/">
                  <h3>Startseite</h3>
                </UniversalLink>
                <UniversalLink href="/kontakt">
                  <p>Kontakt</p>
                </UniversalLink>
                <UniversalLink href="/team">
                  <p>Team</p>
                </UniversalLink>
                <UniversalLink href="/impressum">
                  <p>Impressum</p>
                </UniversalLink>
                <UniversalLink href="/datenschutz">
                  <p>Datenschutz</p>
                </UniversalLink>
                <div className='social'>
                  <UniversalLink href="https://www.instagram.com/parkinsonnetzwerkostsachsen/">
                    <i className="instagram">icon</i>
                  </UniversalLink>
                  <UniversalLink href="https://www.facebook.com/people/Parkinsonnetzwerkostsachsen/100089955132459/">
                    <i className="facebook">icon</i>
                  </UniversalLink>
                </div>
              </div>
            </div>
          </div>
          <div className="copyright">
            All Right Reserved by <b>PANOS</b> © 2025
          </div>
        </Container>
      </footer>
    </>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
